import React from 'react'

const DashboardPage = () => {
  return (
    <div>
      DashBoard Page
    </div>
  )
}

export default DashboardPage;
